(() => {
  if (window.cfDiscountUiReady) return;
  window.cfDiscountUiReady = true;
  const closed = new WeakSet();
  const isDiscount = element => element.querySelector('[data-testid="klaviyo-form-RudgFe"]') || /(?:get|unlock)\s+10%\s+off/i.test(element.textContent || '');
  const quiet = () => {
    const modals = [...document.querySelectorAll('[data-kl-scroll-locking-modal]')];
    modals.filter(isDiscount).forEach(modal => {
      if (modal.dataset.cfDiscountHidden !== 'true') modal.dataset.cfDiscountHidden = 'true';
      const close = modal.querySelector('button[aria-label="Close dialog"]');
      if (close && !closed.has(modal)) { closed.add(modal); close.click(); }
    });
    document.querySelectorAll('[class*="kl-teaser-"]').forEach(teaser => {
      if ((teaser.classList.contains('kl-teaser-RudgFe') || isDiscount(teaser)) && teaser.dataset.cfDiscountHidden !== 'true') teaser.dataset.cfDiscountHidden = 'true';
    });
    const anotherModal = [...document.querySelectorAll('[data-kl-scroll-locking-modal]')].some(modal => !isDiscount(modal) && getComputedStyle(modal).display !== 'none');
    if (!anotherModal && document.body.classList.contains('klaviyo-prevent-body-scrolling')) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  };
  const boot = () => {
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; quiet(); });
    };
    quiet();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
